import React from 'react';
import classnames from 'classnames';
import License from '../../../License';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import MatureIndicator from '../../../SubmissionDetails/_partials/MatureIndicator';
import s from './Tier.scss';
var Tier = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, isMature = _b.isMature, author = _b.author, publishedTime = _b.publishedTime, _c = _b.extended, _d = _c === void 0 ? {} : _c, license = _d.license, className = _a.className, contentClassName = _a.contentClassName;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return (React.createElement("div", { className: classnames(s['root'], className, contentClassName) }, isExtendedLoaded && (React.createElement("div", { className: s['misc'] },
        isMature && React.createElement(MatureIndicator, null),
        React.createElement("div", { className: s['license'] },
            React.createElement(License, { license: license, author: author, publishedTime: publishedTime }))))));
};
Tier.displayName = 'Tier';
export default Tier;
//# sourceMappingURL=Tier.js.map